export const SIZE_OPTIONS = [
    { value: "XS", key: "Extra-small" },
    { value: "S", key: "Small" },
    { value: "M", key: "Medium" },
    { value: "L", key: "Large" },
    { value: "XL", key: "Extra-large" },
    { value: "XXL", key: "Extra-extra-large" }
  ];
  
  export const GENDER_OPTIONS = [
    { key: "Male", value: "Men" },
    { key: "Female", value: "Women" },
    { key: "Neutral", value: "Neutral" }
];
export const TOGGLE_OPTIONS = { key: "toggle_hide_size", value: false };  
export const ACCEPT_OPTIONS = "image/png, image/jpeg, image/jpg, image/webp";

export const CUSTOM_BUTTON_OPTIONS = {
    S1: "s1",
    S2: "s2",
    S3: "s3",
    S4: "s4",
    S5: "s5",
    S6: "s6",
    S7: "s7",
    S8: "s8",
    S9: "s9",
}

export const sizeMap = {
    s1: { width: '193px', height: '48px', font: "16px", lineHeight: "20px" },
    s2: { width: '156px', height: '40px', font: "14px", lineHeight: "17.5px"  },
    s3: { width: '180px', height: '48px', font: "16px", lineHeight: "20px"  },
    s4: { width: '84px', height: '40px', font: "14px", lineHeight: "17.5px"  },
    s5: { width: '173px', height: '40px', font: "14px", lineHeight: "17.5px"  },
    s6: { width: '101px', height: '48px', font: "16px", lineHeight: "20px"  },
    s7: { width: '110px', height: '40px', font: "14px", lineHeight: "17.5px"  },
    s8: { width: '206px', height: '40px', font: "14px", lineHeight: "17.5px"  },
    s9: { width: '110px', height: '32px', font: "14px", lineHeight: "17.5px"  },
  };


export const BROWSEPAGE_FILTER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ#"

export const OPTIONS_PER_PAGE = {
  PRODUCTS: 12,
}

export const sizeMapping = [
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL'
]

export const PRODUCT_DETAILS_TOGGLE_OPTIONS = {
  designer: "designer",
  description: "description"
}